module.exports = function(bootstrap) {
    bootstrap.run(["Service", "services", function (Service, services) {
        new Service({
            name: 'getClaimActivityV2',
            group: "dpsext",
            url: "/dpsext/x-services/spendingAcct/v2/claim/activity",
            contentType: 'application/json',
            fetch: function(payload) {
                this.payload = payload;
                return this.get(this.payload);
            }
        });
    }]);
};